import { useDecision } from '@optimizely/react-sdk'
import { useDispatch } from 'react-redux'

import actions from 'actions/auth'

/**
 * Experiments running on home page that controls order or visibility
 * of homepage sections should be placed here
 */

export const useGetHomePageExperiments = () => {
  /** Immersive Hero experiment uses Optimizely FX
   */
  const [immersiveHeroEnabledDecision] = useDecision('beetroots_ofx_homepage_immersive_hero_test')
  const isImmersiveHeroEnabled = immersiveHeroEnabledDecision.variationKey === 't1'

  return {
    isImmersiveHeroEnabled,
  }
}

export const useGetMenuData = () => {
  const dispatch = useDispatch()
  const dispatchRedirectLoggedInUser = () => dispatch(actions.redirectLoggedInUser)

  return {
    dispatchRedirectLoggedInUser,
  }
}
